module.exports = __webpack_public_path__ + "assets/a3272d9d2f06b8d3d7d9541a0959cc18.png";